import { Component, OnInit, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StripePaymentCardService } from '../../../providers/stripe-payment-card.service';
import { faSave, faCreditCard, faPlus, faUser, faPhoneSquare, faAt, faSpinner } from '@fortawesome/pro-regular-svg-icons';
import { SmsAbstractAppPage } from '../../sms-abstract-app-page';
import { Stripe_credit_card } from '../../../models/accounting/banking/stripe_credit_card';
import { Stripe_customer } from 'src/app/models/accounting/banking/stripe_customer';

@Component({
  standalone: false,
  selector: 'app-stripe-modal-add-credit-card',
  templateUrl: './stripe-modal-add-credit-card.component.html',
styleUrls:  ['./stripe-modal-add-credit-card.component.css']
})
export class StripeModalAddCreditCardComponent extends SmsAbstractAppPage implements OnInit {

  faSave = faSave;
  faCreditCard = faCreditCard;
  faPlus = faPlus;
  faUser = faUser;
  faPhoneSquare = faPhoneSquare;
  faAt = faAt;
  faSpinner = faSpinner;

  card_model: Card_model = new Card_model();
  card_added$: EventEmitter<Stripe_credit_card> = new EventEmitter<Stripe_credit_card>();
  display_add_customer: boolean = false;
  sms_customer_list: Stripe_customer[] = [];
  selected_customer: Stripe_customer = new Stripe_customer({system_customer_id: null});
  cardSaving: boolean = false;

  private _competition_organizer_id: string;

  get competitionOrganizerId(): string {
    return this._competition_organizer_id;
  }

  set competitionOrganizerId(value: string) {
    this.card_model.competition_organizer_id = value;

    console.log("Setting competition organizer id: " + value);

    this._competition_organizer_id = value;
    this.paymentCardService.get_list(this._competition_organizer_id).then(customer_list => {
      this.sms_customer_list.push(this.selected_customer);
      customer_list.forEach((customer, i) => {
        this.sms_customer_list.push(customer);
      });

    }).catch(error => {
      this.handleError(error);
    });
  }

  constructor(public activeModal: NgbActiveModal, private paymentCardService: StripePaymentCardService) {
    super();
  }

  ngOnInit(): void {
  }

  onSubmit(): void {
      if(this.card_model.cardholder_name == ''){
      this.handleError("Cardholder name must have a value!");
      return;
    }
    if(this.card_model.card_number == ''){
      this.handleError("Card # must have a value!");
      return;
    }
    if(this.card_model.cvv == ''){
      this.handleError("CVV must have a value!");
      return;
    }
    if(this.card_model.month == ''){
      this.handleError("Month must have a value!");
      return;
    }
    if(this.card_model.year == ''){
      this.handleError("Year must have a value!");
      return;
    }

    if(this.card_model.email == ''){
      this.handleError("Email must have a value!");
      return;
    }

    if(this.card_model.postal_code == ''){
      this.handleError("Postal code must have a value!");
      return;
    }

    this.cardSaving = true;
    this.paymentCardService.createCard(this.card_model).then(credit_card => {
      this.card_added$.emit(credit_card);
      this.cardSaving = false;
    }).catch(error => {
        this.handleError(error);
        this.cardSaving = false;
    });
  }

    handleAddCustomer(customer: Stripe_customer) {
      this.display_add_customer = false;
      this.sms_customer_list.push(customer);
      this.card_model.cardholder_name = customer.first_name + " " + customer.last_name;
      this.selected_customer = customer;
      this.card_model.email = this.selected_customer.email;
      this.card_model.sms_customer_id = this.selected_customer.sms_customer_id;
      this.card_model.system_customer_id = this.selected_customer.system_customer_id;
      this.card_model.stripe_customer_id = this.selected_customer.stripe_id;
    }

  handleCustomerChange(event: any){
    if(this.selected_customer.hasOwnProperty('system_customer_id')){
      this.card_model.cardholder_name = this.selected_customer.first_name + " " + this.selected_customer.last_name;
      this.card_model.email = this.selected_customer.email;
      this.card_model.sms_customer_id = this.selected_customer.sms_customer_id;
      this.card_model.system_customer_id = this.selected_customer.system_customer_id;
      this.card_model.stripe_customer_id = this.selected_customer.stripe_id;
      console.log("Selected customer: " + this.selected_customer.system_customer_id);
      console.log(this.selected_customer);
    } else {
      console.log("Selected customer: " + this.selected_customer.system_customer_id);
    }
  }

}

class Card_model {

  id: string;

  cardholder_name: string;
  card_number:  string;
  cvv:  string;
  month: string;
  year:  string;
  phone_number: string;
  postal_code:  string;
  country: string;
  email: string;
  competition_organizer_id: string;
  stripe_customer_id: string;
  sms_customer_id: string;
  system_customer_id: string;

  constructor() {
    this.id = null;
    this.cardholder_name = '';
    this.card_number = '';
    this.cvv = '';
    this.month = '';
    this.year = '';
    this.postal_code = '';
    this.country = 'US';
    this.phone_number = "";
    this.email = '';
    this.stripe_customer_id = '';
    this.competition_organizer_id = '';
    this.sms_customer_id = '';
    this.system_customer_id = '';
  }

}
